import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const GlobalFooter = () => {
  const { t } = useLanguage();
  const ownerText = t('legal.platformOwner');

  return (
    <footer className="global-footer" role="contentinfo" style={{ color: '#ffffff' }}>
      <p className="global-footer-text" style={{ color: '#ffffff', WebkitTextFillColor: '#ffffff' }}>
        {ownerText && ownerText !== 'legal.platformOwner'
          ? ownerText
          : 'The platform owner is Uilliam Dettori.'}
      </p>
    </footer>
  );
};

export default GlobalFooter;
